import React from 'react';

export function Close () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <circle cx="6" cy="6" r="6" fill="#717171" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.031 4.031L7.97 7.97M7.969 4.031L4.03 7.97"
      />
    </svg>
  );
}
